export default __webpack_public_path__ + "images/32438b5c1e6a9dc49dd640acad3b45f4-cartebancaire@2x.png";